import React from 'react';
import { Input } from 'antd';
import './NumInput.scss';

export default class NumInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            isFocus: false,
            justEdit: false,
            innerValue: props.value
        };

        this.dataSet = {
            min: props.min ?? 3,
            max: props.max ?? 30,
            mouseInBtn: false
        };
    }

    componentDidUpdate(prevProps) {
        // ✅ 只在外部 value 变化时同步
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value,
                innerValue: this.props.value
            });
        }

        this.dataSet.min = this.props.min ?? 3;
        this.dataSet.max = this.props.max ?? 30;
    }

    inputOnchange = (e) => {
        this.setState({
            innerValue: e.target.value
        });
    }

    onOkValue = () => {
        let newValue = parseFloat(this.state.innerValue);

        if (isNaN(newValue)) {
            this.onCancelValue();
            return;
        }

        newValue = Math.min(this.dataSet.max, Math.max(this.dataSet.min, newValue));

        this.setState({
            value: newValue,
            innerValue: newValue
        });

        this.props.onChange?.(newValue);
    }

    onCancelValue = () => {
        this.setState({
            innerValue: this.props.value
        });
    }

    onAddValue = () => {
        let base = Number(this.props.value ?? 0);
        let newValue = Math.min(this.dataSet.max, base + 1);

        this.setState({
            value: newValue,
            innerValue: newValue
        });

        this.props.onChange?.(newValue);
    }

    onMinusValue = () => {
        let base = Number(this.props.value ?? 0);
        let newValue = Math.max(this.dataSet.min, base - 1);

        this.setState({
            value: newValue,
            innerValue: newValue
        });

        this.props.onChange?.(newValue);
    }

    onBtnClick = (sign) => {
        const action = sign === 0 ? this.onOkValue : this.onMinusValue;

        return () => {
            action();
            this.setState({ justEdit: false });
        };
    }

    inputOnBlur = () => {
        this.setState({ isFocus: false });

        if (this.dataSet.mouseInBtn) {
            this.setState({ justEdit: true });
        } else {
            this.onCancelValue();
        }
    }

    render() {
        const { isFocus, justEdit, innerValue } = this.state;

        const btnProps = {
            className: "btn",
            onMouseEnter: () => this.dataSet.mouseInBtn = true,
            onMouseLeave: () => this.dataSet.mouseInBtn = false
        };

        return (
            <div className={"NumInputWrapper " + (this.props.className || "")}>
                <Input
                    placeholder="number"
                    value={innerValue}
                    onChange={this.inputOnchange}
                    onFocus={() => this.setState({ isFocus: true })}
                    onBlur={this.inputOnBlur}
                />

                <div onClick={this.onBtnClick(0)} {...btnProps}>
                    {isFocus || justEdit ? "√" : "↑"}
                </div>

                <div onClick={this.onBtnClick(1)} {...btnProps}>
                    {isFocus || justEdit ? "×" : "↓"}
                </div>
            </div>
        );
    }
}